import React from "react";
import Headerdash from "./head";
import Sidebar from "./sidebar";
import { useState, useEffect } from "react";
import PageNavigation from "./page";


export default function SummarizeGroupDiscussion() {
  const [SummarizeGroupDiscussionData, setSummarizeGroupDiscussionData] = useState({
    data: [],
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSummarizeGroupDiscussionData = async () => {
      try {
        const response = await fetch("/api/questions/summarizegroupdiscussion", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();

          setSummarizeGroupDiscussionData({
            data: data,
          });

          console.log("Data:", data);
        } else {
          console.error(
            "Failed to fetch Readaloud data. Status:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error fetching Readaloud data:", error);
      } finally {
        setLoading(false); // Set loading to false regardless of success or failure
      }
    };

    fetchSummarizeGroupDiscussionData();
  }, []); // Empty dependency array to fetch data only once on mount

  return (
    <div>
      <Headerdash />
      <Sidebar />
      <PageNavigation heading="Summarize Group Discussion" id={SummarizeGroupDiscussionData.data}/>
 
    </div>
  );
}
